import { DateTime } from 'luxon';

/**
 * Converts an date string from backend response (YYYY-MM-DD) to be displayed in receipt result page (DD.MM.YYYY)
 */
export function convertIsoDateToDisplay(isoDate?: string): string {
    if (!isoDate) {
        return '';
    }
    const [year, month, day] = isoDate.split('-');
    return `${day}.${month}.${year}`;
}

/**
 * Converts a date string from frontend (DD/MM/YYYY) format to ISO format (YYYY-MM-DD) to pass to backend.
 */
export function convertDateToIso(date: string): string {
    // Validate the input format (DD/MM/YYYY)
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(date)) {
        return ''; // Return an empty string for invalid input
    }
    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

/**
 * Converts a session started date string to a display format (HH:mm:ss UTC+X) based on the station timezone
 */
export function convertSessionStartedToDisplay(sessionStarted?: string, stationTimezone?: string): string {
    if (!sessionStarted || !stationTimezone) return '';

    const zone = stationTimezone.toLowerCase() === 'utc' ? 'UTC' : stationTimezone;
    const dt = DateTime.fromISO(sessionStarted, { zone });

    // Check if the DateTime is valid
    if (!dt.isValid) {
        return '';
    }

    const timeStr = dt.toFormat('HH:mm:ss');
    // Fix offset calculation - convert minutes to hours properly
    const offsetHours = dt.offset / 60;
    const offsetFormatted = `UTC${offsetHours >= 0 ? '+' : ''}${offsetHours.toFixed(offsetHours % 1 === 0 ? 0 : 1)}`;

    return `${timeStr} (${offsetFormatted})`;
}

/**
 * Converts durationMs to hour min second display format (e.g 1 hour 2 min 3 sec)
 */
export function convertDurationMsToDisplay(durationMs?: number): string {
    if (!durationMs) {
        return '';
    }

    const totalSeconds = Math.floor(durationMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
        return `${hours} hour ${minutes} min ${seconds} s`;
    } else if (minutes > 0) {
        return `${minutes} min ${seconds} s`;
    } else {
        return `${seconds} s`;
    }
}
